import { GridPosition } from '~/types/drill'

export function getGridPosition(index: number): GridPosition {
  let colPosition = [0, 0]
  let rowPosition = [0, 0]

  switch (index) {
    case 0:
      colPosition = [1, 3]
      rowPosition = [1, 3]
      break

    case 1:
      colPosition = [2, 4]
      rowPosition = [3, 5]
      break

    case 2:
      colPosition = [1, 3]
      rowPosition = [5, 7]
      break

    case 3:
      colPosition = [2, 4]
      rowPosition = [7, 9]
      break

    case 4:
      colPosition = [4, 6]
      rowPosition = [7, 9]
      break

    case 5:
      colPosition = [5, 7]
      rowPosition = [5, 7]
      break

    case 6:
      colPosition = [6, 8]
      rowPosition = [3, 5]
      break

    case 7:
      colPosition = [8, 10]
      rowPosition = [3, 5]
      break

    case 8:
      colPosition = [9, 11]
      rowPosition = [5, 7]
      break

    case 9:
      colPosition = [8, 10]
      rowPosition = [7, 9]
      break

    case 10:
      colPosition = [9, 11]
      rowPosition = [9, 11]
      break

    default:
      break
  }

  return {
    gridColumnStart: colPosition[0],
    gridColumnEnd: colPosition[1],
    gridRowStart: rowPosition[0],
    gridRowEnd: rowPosition[1],
  }
}
